import React from "react";

import icon_team_leader from '../../../assets/img/icon-team-leader.svg';

export const MemberItem = ({ member, energyType }) => {
    const energyStyles = {
      always: { colorClass: "text-always", label: "Always" },
      never: { colorClass: "text-never", label: "Never" }
    };
  
    const { colorClass, label } = energyStyles[energyType] || energyStyles.always;
    
    return (
      <div key={`i_${member.id}`} className="member-item mb-2 d-flex align-items-center border rounded-lg p-2">
        <div className="d-flex align-items-center text-reset text-decoration-none flex-fill">
          <div className="pr-2">
            <img 
              width="32" 
              height="32" 
              alt={member.first_name} 
              src={member.avatar} 
              className="rounded-circle"
            />
          </div>
          <div>
            <p className="h6 mb-1 text-truncate text-nowrap">
              {member.first_name} {member.last_name}
              {member.leader === 1 && (
                <img 
                  className="talents-icon-arrow ml-2 mb-1" 
                  src={icon_team_leader} 
                  width="16" 
                  height="auto" 
                  alt="Team Leader" 
                />
              )}
            </p>
          </div>
  
          <div className='ml-auto'>
            <p className="mb-0">
              <i className="icon mr-1">
                <svg width="10" height="10" className={`mt-n1 ${colorClass}`}>
                  <circle cx="5" cy="5" r="5" fill="currentColor" />
                </svg>
              </i>
              <span className='small'>{label}</span>
            </p>
          </div>
        </div>
      </div>
    );
  };